/**
 * ComingSoon — shared markers for features that exist in the UI but aren't
 * fully built out yet (this is an MVP; keep dropping this in wherever a
 * control needs to say "not yet" instead of silently doing the wrong thing).
 */

import type { ReactNode } from 'react';
import { Sparkle16Regular } from '@fluentui/react-icons';

export function ComingSoonBadge({ label = 'Coming soon' }: { label?: string }) {
    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                padding: '2px 8px',
                borderRadius: 999,
                background: 'rgba(43,166,187,0.12)',
                border: '1px solid rgba(43,166,187,0.3)',
                color: '#0e7490',
                fontSize: 10,
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                whiteSpace: 'nowrap',
            }}
        >
            <Sparkle16Regular style={{ width: 12, height: 12 }} />
            {label}
        </span>
    );
}

interface ComingSoonNoticeProps {
    title?: string;
    message: ReactNode;
}

export function ComingSoonNotice({ title = 'Coming soon', message }: ComingSoonNoticeProps) {
    return (
        <div
            style={{
                display: 'flex',
                gap: 10,
                padding: '12px 14px',
                background: 'rgba(43,166,187,0.08)',
                border: '1px solid rgba(43,166,187,0.25)',
                borderLeft: '3px solid #2ba6bb',
                borderRadius: 8,
            }}
        >
            <Sparkle16Regular style={{ width: 16, height: 16, color: '#0e7490', flexShrink: 0, marginTop: 2 }} />
            <div>
                <p style={{ margin: 0, fontWeight: 700, fontSize: 13, color: '#0e7490' }}>{title}</p>
                <p style={{ margin: '2px 0 0', fontSize: 12.5, color: '#475569', lineHeight: 1.5 }}>{message}</p>
            </div>
        </div>
    );
}
